import { render, staticRenderFns } from "./flagAttivita.vue?vue&type=template&id=5e1f0e3a"
import script from "./flagAttivita.vue?vue&type=script&lang=js"
export * from "./flagAttivita.vue?vue&type=script&lang=js"
import style0 from "./flagAttivita.vue?vue&type=style&index=0&id=5e1f0e3a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports